<div class="image" data-cy="nmo-image">
  @if (hasArticlePreviewRights()) {
    <a
      class="material-icons copyUrlButton"
      href="javascript:void(0);"
      (click)="copyImageUrl($event)"
      #tooltip="matTooltip"
      matTooltip="Bild-URL kopieren"
      matTooltipHideDelay="100"
    >
      content_copy
    </a>
  }
  <lib-image-source-set
    [sourceConfig]="sourceConfig()"
    [defaultCropConfig]="defaultCrop()"
    [alt]="altText()"
    [priority]="priority()"
  ></lib-image-source-set>
  @if (text() && text() !== '') {
    <div class="title" [innerHTML]="text()"></div>
  }
  @if (bylineAuthors()?.length > 0) {
    <div class="reference" [innerHTML]="'&copy; ' + bylineAuthors()[0]"></div>
  }
</div>
